import { render, staticRenderFns } from "./owners.vue?vue&type=template&id=30b35168&scoped=true&"
var script = {}
import style0 from "./owners.vue?vue&type=style&index=0&id=30b35168&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b35168",
  null
  
)

export default component.exports